
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function AdditionalConcerns() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    siteLocation: "",
    engineer: "",
    date: "",
    estimatedTime: "",
    jobReference: "",
    safetyIssues: "",
    proximity: "",
    specialistEquipment: "",
    cableRoute: "",
    otherComments: "",
    outOfHours: "",
    needCOSS: "",
    otherContractors: "",
    contractorDetails: "",
    photosTaken: "",
    photoComments: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Additional Concerns submitted!");
    navigate(-1);
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            Additional Concerns
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Site / Location</label>
                <input type="text" className="form-control" name="siteLocation" value={form.siteLocation} onChange={handleChange} required placeholder="Site / Location" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Engineer</label>
                <input type="text" className="form-control" name="engineer" value={form.engineer} onChange={handleChange} required placeholder="Engineer" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Date</label>
                <input type="date" className="form-control" name="date" value={form.date} onChange={handleChange} required style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Estimated time</label>
                <input type="text" className="form-control" name="estimatedTime" value={form.estimatedTime} onChange={handleChange} required placeholder="Estimated time" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Job Reference</label>
                <input type="text" className="form-control" name="jobReference" value={form.jobReference} onChange={handleChange} required placeholder="Job Reference" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Any Safety issues eg – Working at height</label>
                <textarea className="form-control" name="safetyIssues" value={form.safetyIssues} onChange={handleChange} rows={2} placeholder="Any Safety issues eg – Working at height" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Proximity to on or near the line</label>
                <textarea className="form-control" name="proximity" value={form.proximity} onChange={handleChange} rows={2} placeholder="Proximity to on or near the line" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Specialist Equipment Required eg…</label>
                <textarea className="form-control" name="specialistEquipment" value={form.specialistEquipment} onChange={handleChange} rows={2} placeholder="Specialist Equipment Required eg…" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Type of Cable Route EG. Duct/Concrete/Direct</label>
                <textarea className="form-control" name="cableRoute" value={form.cableRoute} onChange={handleChange} rows={2} placeholder="Type of Cable Route EG. Duct/Concrete/Direct" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Any Other Comments</label>
                <textarea className="form-control" name="otherComments" value={form.otherComments} onChange={handleChange} rows={2} placeholder="Any Other Comments" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Does the work need to be done out of normal working hours</label>
                <div>
                  <label className="me-3"><input type="radio" name="outOfHours" value="YES" checked={form.outOfHours === "YES"} onChange={handleRadioChange} /> YES</label>
                  <label><input type="radio" name="outOfHours" value="NO" checked={form.outOfHours === "NO"} onChange={handleRadioChange} /> NO</label>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Do we need a COSS</label>
                <div>
                  <label className="me-3"><input type="radio" name="needCOSS" value="YES" checked={form.needCOSS === "YES"} onChange={handleRadioChange} /> YES</label>
                  <label><input type="radio" name="needCOSS" value="NO" checked={form.needCOSS === "NO"} onChange={handleRadioChange} /> NO</label>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Are Other Contractors on Site</label>
                <div>
                  <label className="me-3"><input type="radio" name="otherContractors" value="YES" checked={form.otherContractors === "YES"} onChange={handleRadioChange} /> YES</label>
                  <label><input type="radio" name="otherContractors" value="NO" checked={form.otherContractors === "NO"} onChange={handleRadioChange} /> NO</label>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">If Yes Who/Contact Name & Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="contractorDetails"
                  value={form.contractorDetails}
                  onChange={handleChange}
                  placeholder="Contact Name & Number"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }}
                />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Have Supporting Photo’s Been Taken</label>
                <div>
                  <label className="me-3"><input type="radio" name="photosTaken" value="YES" checked={form.photosTaken === "YES"} onChange={handleRadioChange} /> YES</label>
                  <label><input type="radio" name="photosTaken" value="NO" checked={form.photosTaken === "NO"} onChange={handleRadioChange} /> NO</label>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">If photographs taken please attach / send with report</label>
                <textarea className="form-control" name="photoComments" value={form.photoComments} onChange={handleChange} rows={2} placeholder="If photographs taken please attach / send with report" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2" style={{ backgroundColor: "#8b1634", borderRadius: "30px", boxShadow: "0 4px 12px rgba(139,22,52,0.3)" }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdditionalConcerns;
